import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '$constants/alerts';
import { errorHandler, successHandler } from '$store/utils';
import { userLanguage, ValidLanguages } from '$translations/index';
import {
  CandidateAiDataBuilder,
  OverrideAiScoresInput,
} from '../candidate-ai.types';

/**
 *  @deprecated This endpoint will be get erased soon
 */
export const overrideAiScores = (builder: CandidateAiDataBuilder) =>
  builder.mutation<any, OverrideAiScoresInput>({
    query: ({ candidateId, payload }) => ({
      url: `/candidates/ai/${candidateId}/override`,
      method: 'POST',
      body: payload,
    }),
    transformResponse: (resp) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.AiScoreOverrideSuccessfully
          : SuccessMessageEn.AiScoreOverrideSuccessfully,
        true,
        false
      );

      return resp;
    },
    transformErrorResponse: (resp) => {
      errorHandler(
        '[OverrideAiScores]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.ServerError
          : ErrorMessageEn.ServerError,
        resp,
        true,
        false
      );
      return resp;
    },
    invalidatesTags: () => [{ type: 'aiData' }],
  });
